import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/affiliates/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/affiliates', data)
  },
  get(id) {
    return http.get(`/api/v1/affiliates/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/affiliates/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/affiliates/${id}/status`, null, {
      params: { status },
    });
  }
}
